import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchPost, objectify } from '../../utils';

export const fetch = async (query: { ProductId: number; Page: number; BatchSize?: number; filters?: any }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { ProductId, Page, BatchSize = DEFAULT_PAGE_SIZE, filters } = query;
  const respType = 'Inline';

  return fetchPost(
    `/InventoryEnquiry/Product/${ProductId}/Pricing/Schedules`,
    filters,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        PricingScheduless: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.PricingScheduless) {

            return {
              records: result.PricingScheduless.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
